import React from "react";
import { useParams } from "react-router-dom";

const Refund = () => {
  const { lang } = useParams();

  return (
    <div
      className="container d-flex justify-content-center align-items-center min-vh-100 px-3"
      style={lang === "ar" ? { direction: "rtl" } : {}}
    >
      <div className="card w-100 w-md-75 w-lg-50">
        <div className="card-body">
          <h1 className="card-title text-center fs-4">
            {lang === "ar" ? "إدارة المشتريات داخل التطبيق واسترداد الأموال" : "Managing In-App Purchases & Refunds"}
          </h1>
          <p className="card-text">
            {lang === "ar"
              ? "يمكنك إدارة مشترياتك داخل التطبيق مباشرة من خلال حسابك على Google Play:"
              : "You can manage your in-app purchases directly through your Google Play account:"}
          </p>
          <ol className="list-group list-group-numbered mb-3">
            <li className="list-group-item">
              {lang === "ar" ? "افتح تطبيق متجر Google Play." : "Open the Google Play Store app."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? (
                <>اضغط على أيقونة ملفك الشخصي واختر <strong>المدفوعات والاشتراكات</strong> &gt; <strong>سجل الطلبات</strong></>
              ) : (
                <>Tap your profile icon and select <strong>Payments & Subscriptions</strong> &gt; <strong>Order History</strong></>
              )}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? "ابحث عن العنصر \"Khat\" في سجل الطلبات لعرض التفاصيل أو طلب استرداد."
                : "Find the item \"Khat\" in your order history to view details or request a refund."}
            </li>
          </ol>
          <h2 className="h5 text-center">
            {lang === "ar" ? "سياسة الاسترداد" : "Refund Policy"}
          </h2>
          <ul className="list-group mb-3">
            <li className="list-group-item">
              {lang === "ar" ? "تتم معالجة طلبات الاسترداد من خلال Google Play وتخضع لسياسة الاسترداد الخاصة بهم."
                : "Refunds for in-app purchases are handled by Google Play and are subject to their refund policy."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? "إذا كنت تعتقد أنك مؤهل للحصول على استرداد، يرجى الاتصال بدعم Google Play."
                : "If you believe you are eligible for a refund, please contact Google Play Support."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? "يمكنك طلب استرداد من خلال سجل طلبات Google Play، ولكن لاحظ أن Google Play يوفر عادةً استردادًا خلال مدة زمنية محدودة (عادةً 48 ساعة) بعد الشراء."
                : "You can request a refund directly from your Google Play order history, but note that Google Play typically provides refunds within a limited time window (usually 48 hours) after purchase."}
            </li>
          </ul>
          <h2 className="h5 text-center">
            {lang === "ar" ? "ملاحظات هامة" : "Important Notes"}
          </h2>
          <ul className="list-group mb-3">
            <li className="list-group-item">
              {lang === "ar" ? "المنتجات داخل التطبيق هي عمليات شراء لمرة واحدة، ولا توجد عمليات إلغاء أو تجديد مرتبطة بها."
                : "In-app products are one-time purchases, and there are no cancellation or renewal processes associated with them."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? "نحن لا نقدم استردادًا مباشرًا. يرجى الرجوع إلى سياسات Google لمعرفة كيفية طلب استرداد."
                : "We do not provide refunds directly. Please refer to Google's policies for information on how to request a refund."}
            </li>
          </ul>
          <h2 className="h5 text-center">
            {lang === "ar" ? "تغييرات في المنتجات داخل التطبيق" : "Changes to In-App Products"}
          </h2>
          <ul className="list-group">
            <li className="list-group-item">
              {lang === "ar" ? "نحتفظ بالحق في تعديل أسعار أو توفر المنتجات داخل التطبيق في أي وقت. ومع ذلك، بمجرد إجراء عملية شراء، لا يمكن استردادها إلا وفقًا لسياسة استرداد Google Play."
                : "We reserve the right to modify the pricing or availability of in-app products at any time. However, once a purchase is made, it is non-refundable except under the Google Play refund policy."}
            </li>
            <li className="list-group-item">
              {lang === "ar" ? "سيتم إخطارك بأي تغييرات كبيرة مسبقًا، ولكن استمرارك في استخدام المنتج يعني قبولك للشروط الجديدة."
                : "You will be notified of any significant changes in advance, but your continued use of the product implies acceptance of the new terms."}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Refund;